import styled from 'styled-components';
import { CommonContainer } from './CommonStyles';

export const FormContainer = styled(CommonContainer).attrs({ as: 'form' })`
  justify-content: space-between;
`;

export const TextareaWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;
`;

export const StyledTextarea = styled.textarea`
  width: 96%;
  height: 280px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 30px; // CharacterCount를 위한 공간 확보

  @media (max-width: 768px) {
    width: 95%;
    height: 230px;
    font-size: 18px;
  }
`;

export const CharacterCount = styled.span`
  position: absolute;
  bottom: 10px;
  right: 20px;
  color: #666;
  font-size: 14px;
  background: transparent;

  @media (max-width: 768px) {
    right: 25px;
    font-size: 12px;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;

  &:hover {
    background-color: #0056b3;
  }

  &:disabled {
    cursor: wait;
    opacity: 0.7;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px;
  }
`;

export const FormGuide = styled.p`
  width: 100%;
  margin: 0 0 8px;
  color: #615779;
  font-size: 14px;
`;

export const ExampleList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  margin-bottom: 8px;
`;

export const ExampleButton = styled.button`
  padding: 7px 10px;
  border: 1px solid #ddd6f3;
  border-radius: 999px;
  background: #f8f6ff;
  color: #4a3b70;
  cursor: pointer;
  font-size: 13px;

  &:hover, &:focus-visible {
    border-color: #7b68ad;
    background: #efebff;
  }
`;

export const ValidationMessage = styled.p`
  min-height: 20px;
  width: 100%;
  margin: 0 0 6px;
  color: #b42318;
  font-size: 14px;
  font-weight: 700;
`;
